// import $ from "jquery";

/** @module services/resize-tracker
* This service is responsible for setting up latest x and y position of mouse on the context.
*/
export default function(context){
  // window.onresize = function(){
  //   let screen = $("#screen")
  //   let width = screen.width();
  //   let height = screen.height();
  //   canvas.width=width;
  //   canvas.height=height;
  // }
}
